import Vue from "vue";
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from "vue-router";
import Home from "../views/Home.vue";
import Detail from "../views/Detail.vue";
import Login from "../views/Login.vue";
import ApiService from "@/services/ApiService";

Vue.use(VueRouter);

const authenticatedRoute = (
  route: Route,
  redirect: Route,
  next: NavigationGuardNext<any>
) => {
  // check if a user is logged in, else return to login page
  if (!ApiService.isLoggedIn()) next({ name: "Login" });
  else next();
};

const routes: Array<RouteConfig> = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/",
    name: "Home",
    beforeEnter: authenticatedRoute,
    component: Home,
  },
  {
    path: "/details/:id",
    name: "Detail",
    props: true,
    beforeEnter: authenticatedRoute,
    component: Detail,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
];

const router = new VueRouter({
  mode: "history",
  //base: process.env.BASE_URL,
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes,
});

export default router;
